import { useState, useEffect } from 'react';
import { fetchAllMarketingCreatives } from './utils';


export const useMarketingCreatives = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadMarketingCreatives = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const creatives = await fetchAllMarketingCreatives();
      setData(creatives);
    } catch (err) {
      console.error('Failed to load marketing creatives:', err);
      setError(err.message || 'Failed to load marketing creatives');
      setData([]); // Fallback to empty array
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadMarketingCreatives();
  }, []);

  const refetch = async () => {
    await loadMarketingCreatives();
  };

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};

export const fetchMarketingCreativeDetail = async (documentId) => {
  try {
    const url = `${process.env.REACT_APP_STRAPI_API_ENDPOINT}/fetch-partner-marketing-creative?documentId=${documentId}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRAPI_API_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching marketing creative detail for documentId ${documentId}:`, error);
    throw error;
  }
};
